export enum APP_ROUTES {
  HOME = '/home',
  ASSET = 'asset',
  NOTIFICATIONS = 'notifications',
  SETTING = 'settings',
}
